import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import TableRestockingComponent from '../components/TableRestockingComponent';
import { validateSession } from '../utils/functions';
import { navigateTo } from '../utils/navigation';

// ENI-199: el espejo de "Reposición de stock" (retail) para insumos de cafetería.
// Misma tabla `restocking` y mismo endpoint, partidos por ?type=supplies.
//
// A diferencia de retail NO hay FAB de alta: la reposición de insumos se carga desde
// Insumos, donde se eligen los insumos y sus cantidades (botón "Reponer").
//
// ENI-32: tampoco paga. El FAB de pago masivo quedaba llamando a `changeMasiveStatus()`, un
// método que ya no existe en TableRestockingComponent (se borró junto con la selección por
// checkboxes): entraba en modo pago con "$0" y sin nada que tildar, y "Ingresar Pago" tiraba
// TypeError. El pago vive en "Facturas a pagar", que es donde está la factura del proveedor.
class CafeteriaReposicionesPage extends Component {

    constructor() {
        const cachedRole = Number(localStorage.getItem('role') || 0);
        super();
        this.state = {
            checked: !!localStorage.getItem('token'),
            role: cachedRole,
        };
    }

    async componentDidMount() {
        const role = await validateSession(true);
        this.setState({ checked: true, role });
    }

    goToInsumos = () => {
        navigateTo('/cafeteriaInsumos');
    }

    irAFacturas = () => {
        navigateTo('/providerInvoices');
    }

    render() {
        if (!this.state.checked) {
            return (<div></div>);
        }

        return (
            <div className="container-fluid">
                <div className="row">
                    <SidebarComponent itemSelected={32} role={this.state.role} />
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4" style={{ paddingBottom: '80px' }}>
                            <HeaderComponent title="Cafetería" subtitle="Reposición de insumos" />
                            {/* Mismo tratamiento que RestockingPage: quien venía acá a pagar
                                encuentra el camino en vez de un botón que desaparece. */}
                            {this.state.role === 1 ? (
                                <div className="mb-3">
                                    <button type="button" className="btn btn-sm btn-white" onClick={this.irAFacturas}>
                                        Ir a Facturas a pagar
                                    </button>
                                    <small className="text-muted ml-2">
                                        Los pagos a proveedores se hacen desde ahí.
                                    </small>
                                </div>
                            ) : null}
                            <p className="text-muted" style={{ marginTop: '-10px' }}>
                                Las reposiciones se cargan desde <button type="button" className="btn btn-link p-0 align-baseline" onClick={this.goToInsumos}>Insumos</button>, con el botón «Reponer». Las cantidades están en paquetes cerrados.
                            </p>
                            <TableRestockingComponent role={this.state.role} type="supplies" />
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

export default CafeteriaReposicionesPage;
